// extracted by mini-css-extract-plugin
export default {"transitionIn":"custom_transitionIn__+Guto","moveIn":"custom_moveIn__MRYKG","popUp":"custom_popUp__lHTVI","growIn":"custom_growIn__aL0g9"};